import React from 'react';
import PropTypes from 'prop-types';
import Icon from "../icon/icon";
export var CLASSNAME = 'Icons-loading-arrows';
export var ID = 'icon-loading-arrows';
/* eslint-disable max-len */

export var SVGLoadingArrows = function SVGLoadingArrows() {
  return React.createElement("symbol", {
    id: ID,
    viewBox: "0 0 15 20"
  }, React.createElement("path", {
    d: "M8.398,13.33l-3.32,3.34L8.408,20v-2.13c1.313-0.268,2.533-0.874,3.54-1.761c1.257-1.09,2.116-2.567,2.44-4.199c0.32-1.564,0.109-3.19-0.601-4.62c-0.685-1.368-1.798-2.475-3.17-3.15c1.21,0.834,2.112,2.043,2.569,3.44c0.445,1.296,0.445,2.704,0,4c-0.434,1.238-1.271,2.295-2.379,3c-0.723,0.477-1.55,0.771-2.41,0.859V13.33z"
  }), React.createElement("path", {
    d: "M0.798,12.609c0.684,1.363,1.793,2.466,3.16,3.141c-1.191-0.806-2.092-1.973-2.57-3.33c-0.444-1.296-0.444-2.704,0-4c0.435-1.239,1.273-2.295,2.381-3c0.723-0.476,1.549-0.771,2.41-0.86v2.1l3.329-3.33L6.168,0v2.13c-1.342,0.254-2.591,0.862-3.62,1.76c-1.257,1.09-2.115,2.568-2.439,4.2C-0.157,9.632,0.085,11.218,0.798,12.609z"
  }));
};
/* eslint-disable max-len */

var LoadingArrows = function LoadingArrows(props) {
  return React.createElement(Icon, {
    id: ID,
    className: props.className ? "".concat(props.className, " ").concat(CLASSNAME) : CLASSNAME,
    onClick: props.onClick,
    svg: SVGLoadingArrows
  });
};

LoadingArrows.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};
export default LoadingArrows;